import React from 'react';
import { BeforeAfter } from '../canvas/widgets/BeforeAfter';
import { DriftBars } from '../canvas/widgets/DriftBars';
import FitHeatmap from './FitHeatmap';
import { useFit } from '../../hooks/useFit';

interface PersonalizationTabProps {
  clientId?: string;
  /**
   * TASK-832: the sub-asset class a drift breach was opened from, and TASK-830's focused
   * instrument. The tab is a MOUNT POINT — it passes the signal through to the widgets that
   * are already signal-scoped, rather than becoming a second composition of them.
   */
  focusSac?: string;
  focusIsin?: string;
}

const PersonalizationTab: React.FC<PersonalizationTabProps> = ({ clientId, focusSac, focusIsin }) => {
  const fitQuery = useFit(clientId ?? '');

  if (!clientId) {
    return (
      <div className="bg-white rounded-lg shadow p-6 text-sm text-gray-600">
        Select a client to view personalization.
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {fitQuery.isError && (
        <div className="rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          Personalization data could not be loaded.
        </div>
      )}
      <FitHeatmap fit={fitQuery.data} loading={fitQuery.isLoading} />
      <div className="grid gap-6 xl:grid-cols-[minmax(0,1.4fr)_minmax(320px,0.8fr)]">
        <BeforeAfter clientId={clientId} focusIsin={focusIsin} />
        <DriftBars clientId={clientId} focusSac={focusSac} />
      </div>
    </div>
  );
};

export default PersonalizationTab;
